import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { useRoute } from "@react-navigation/native";
import AuthScreen from "../screens/Auth/AuthScreen";
import LandingScreen from "../screens/Auth/LandingScreen";
import ProfileSetupScreen from "../screens/ProfileSetupScreen";
import ForgotPasswordScreen from "../screens/Auth/ForgotPasswordScreen";
import SignUpConfirmationScreen from "../screens/Auth/SignUpConfirmationScreen";
import PasswordReset from "../screens/Auth/PasswordReset";
// DISABLED: Phone verification temporarily disabled
// import PhoneVerificationScreen from "../screens/Auth/PhoneVerificationScreen";
import PrivacyPolicyScreen from "../screens/PrivacyPolicyScreen";
import TermsAndConditionsScreen from "../screens/TermsAndConditions";
import { useColors } from "../hooks/useColors";

type AuthStackParamList = {
  Landing: undefined;
  Auth: undefined;
  ProfileSetup: undefined;
  ForgotPassword: undefined;
  SignUpConfirmation: undefined;
  PasswordReset: { token?: string };
  // DISABLED: Phone verification temporarily disabled
  // PhoneVerification: { phone: string; userId: string };
  PrivacyPolicy: undefined;
  TermsAndConditions: undefined;
};

const AuthStack = createNativeStackNavigator<AuthStackParamList>();

function AuthStackNavigator() {
  const colors = useColors();
  const route = useRoute();
  
  // Get initial screen from route params if provided (for password reset)
  const initialScreen = (route.params as any)?.screen;

  return (
    <AuthStack.Navigator
      initialRouteName={initialScreen || 'Landing'}
      screenOptions={{
        headerBackTitleStyle: { fontFamily: undefined, fontSize: undefined },
        headerTintColor: colors.primary,
        headerTitleStyle: { fontFamily: undefined, fontSize: undefined, color: colors.text },
        headerStyle: {
          backgroundColor: colors.background,
        },
        contentStyle: {
          backgroundColor: colors.background,
        },
      }}
    >
      <AuthStack.Screen
        name="Landing"
        component={LandingScreen}
        options={{
          headerShown: false,
        }}
      />
      <AuthStack.Screen
        name="Auth"
        component={AuthScreen}
        options={{
          title: "Sign In",
          headerShown: false,
        }}
      />
      <AuthStack.Screen
        name="ProfileSetup"
        component={ProfileSetupScreen}
        options={{
          title: "Create Username",
          headerShown: false,
        }}
      />
      <AuthStack.Screen
        name="ForgotPassword"
        component={ForgotPasswordScreen}
        options={{ title: "Reset Password", headerShown: false }}
      />
      <AuthStack.Screen
        name="SignUpConfirmation"
        component={SignUpConfirmationScreen}
        options={{ headerShown: false }}
      />
      <AuthStack.Screen
        name="PasswordReset"
        component={PasswordReset}
        options={{ title: "Password Reset", headerShown: false }}
      />
      {/* DISABLED: Phone verification temporarily disabled */}
      {/*
      <AuthStack.Screen
        name="PhoneVerification"
        component={PhoneVerificationScreen}
        options={{ 
          title: "Verify Phone",
          headerBackVisible: false,
          headerShown: false
        }}
      />
      */}
      <AuthStack.Screen
        name="PrivacyPolicy"
        component={PrivacyPolicyScreen}
        options={{ title: "Privacy Policy" }}
      />
      <AuthStack.Screen
        name="TermsAndConditions"
        component={TermsAndConditionsScreen}
        options={{ title: "Terms and Conditions" }}
      />
    </AuthStack.Navigator>
  );
}

export default AuthStackNavigator;
